import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCheck, IconClose } from '@redteclab/icons'

import { IconListItem, Notification } from 'base-ui'

import { ExampleDiscountTableData } from './ExampleDiscountTableData'

export const ExampleDiscountTable: FC = () => {
  return (
    <>
      <p className="mb-4 mt-6 text-m font-medium">
        <FormattedMessage id="prescriptionBonus.modal.example.title" />
      </p>
      <Notification className="my-4" icon={false} variant="primary">
        <ul className="not-prose m-0 p-0">
          {ExampleDiscountTableData.map(({ header, key, row1, row2 }) => (
            <li className="mb-3 flex" key={key}>
              {/* Left column */}
              <div className="flex flex-1 flex-col">
                <div className="font-medium">{header}</div>
                <div>{row1}</div>
              </div>

              {/* Right column */}
              <div className="flex flex-1 items-center justify-end">
                <div className="rounded-lg border border-dark-primary-min px-2">
                  {row2}
                </div>
              </div>
            </li>
          ))}
          <li className="mt-4 flex border-t border-dark-primary-min pt-4">
            <div className="flex flex-1 flex-col text-m">
              <FormattedMessage id="prescriptionBonus.modal.example.discount.table.row.3.0" />
            </div>
            <div className="flex justify-end rounded-lg border border-dark-primary-min bg-light-primary-low px-2 text-dark-brand">
              <FormattedMessage id="prescriptionBonus.modal.example.discount.table.row.3.1" />
            </div>
          </li>
        </ul>
      </Notification>
      <p className="pb-0 pt-3 text-m font-medium">
        <FormattedMessage id="prescriptionBonus.modal.discount.subtitle" />
      </p>
      <Notification className="my-4" icon={false} severity="warning">
        <ul className="not-prose m-0 p-0">
          <IconListItem className="pb-2" icon={<IconCheck />}>
            <FormattedMessage id="prescriptionBonus.modal.check.coPayments" />
          </IconListItem>
          <IconListItem className="pb-2" icon={<IconCheck />}>
            <FormattedMessage id="prescriptionBonus.modal.check.personaCare" />
          </IconListItem>
          <IconListItem className="pb-2" icon={<IconCheck />}>
            <FormattedMessage id="prescriptionBonus.modal.check.chemist" />
          </IconListItem>
          <IconListItem className="pb-2" icon={<IconCheck />}>
            <FormattedMessage id="prescriptionBonus.modal.check.supplements" />
          </IconListItem>
          <IconListItem
            className="pb-2 text-dark-primary-strong"
            icon={<IconClose />}
          >
            <FormattedMessage id="prescriptionBonus.modal.check.excludedProducts" />
          </IconListItem>
        </ul>
      </Notification>
    </>
  )
}
